import { STEP_RANGE } from '../../constant';

type Props = {
  startStep: number | null;
  endStep: number | null;
};

export default function JobChangeStepGauge({ startStep, endStep }: Props) {
  const startIndex = STEP_RANGE.findIndex((step) => step.id === startStep);
  const foundEndIndex = STEP_RANGE.findIndex((step) => step.id === endStep);
  const endIndex = foundEndIndex === -1 ? startIndex : foundEndIndex;

  return (
    <div className="relative flex h-sm w-full items-center">
      <div className="absolute top-1/2 left-0 h-[2px] w-full -translate-y-1/2 transform bg-border"></div>

      {startIndex !== -1 && endIndex !== -1 && startIndex <= endIndex && (
        <div
          className="absolute top-1/2 h-[2px] -translate-y-1/2 transform bg-primary"
          style={{
            left: `${(startIndex / (STEP_RANGE.length - 1)) * 100}%`,
            width: `${((endIndex - startIndex) / (STEP_RANGE.length - 1)) * 100}%`,
          }}
        ></div>
      )}

      <div className="relative z-2 flex w-full justify-between">
        {STEP_RANGE.map((step, index) => (
          <span
            key={step.id}
            className={`size-xs rounded-full ${
              index >= startIndex && index <= endIndex ? 'bg-primary' : 'bg-border'
            }`}
          ></span>
        ))}
      </div>
    </div>
  );
}
